import L from 'leaflet';

// Esri World Street Map basemap (free, no API key required).
// Switched from OSM (403 block) and CARTO (now requires API key).
// The soft CSS filter on .leaflet-tile-pane (see index.css) gives it
// the playful, less-technical look.
export const PLAYFUL_TILES = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  options: {
    attribution: 'Tiles &copy; Esri',
    maxZoom: 19,
  },
};

// Brand-colored playful pin marker used across all maps.
export function createPlayfulPinIcon() {
  return L.divIcon({
    className: '',
    html: `<div style="width:32px;height:40px;display:flex;align-items:flex-start;justify-content:center">
      <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 1C8.82 1 3 6.82 3 14C3 23.5 16 39 16 39C16 39 29 23.5 29 14C29 6.82 23.18 1 16 1Z" fill="#10b981" stroke="white" stroke-width="2"/>
        <circle cx="16" cy="14" r="4.5" fill="white"/>
      </svg>
    </div>`,
    iconSize: [32, 40],
    iconAnchor: [16, 39],
    popupAnchor: [0, -36],
  });
}